import { Component, OnInit, Input, PLATFORM_ID, Inject, AfterViewInit, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { ComponentRendering } from "@sitecore-jss/sitecore-jss-angular";
import { JssStylingService } from "../../jss-styling.service";
import { TranslateService } from "@ngx-translate/core";
import { ApiService } from "../../services/api.service";
import { Swiper } from "swiper";
import { CustomDeviceDetectorService } from "../../services/custom-device-detector.service";
import { isPlatformServer } from "@angular/common";
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';
@Component({
    selector: "app-investment-product-module",
    templateUrl: "./investment-product-module.component.html",
    styleUrls: ["./investment-product-module.component.scss"],
})
export class InvestmentProductModuleComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() rendering: ComponentRendering;
    @ViewChild('CardSlider', { static: false }) swiperSlider!: ElementRef;
    @ViewChild('FilterSlider', { static: false }) swiperFilter!: ElementRef;
    dynamicClass: string;
    SelectedCardTitle: string;
    visibleShowmore: boolean = true;
    sc_params: string = "";
    swiper: Swiper;
    swiper1: Swiper;
    public contextSubscription: Subscription;
    language:string;
    productCategoryList: ProductCategory[] = [];
    public isMobile: boolean;
    _isPlatformServer: boolean = false;

    constructor(
        @Inject(PLATFORM_ID) public readonly platformId: string,
        public jssStylingService: JssStylingService,
        protected apiService: ApiService,
        public jssContext: JssContextService,
        private deviceDetector: CustomDeviceDetectorService,
        public translate: TranslateService,
    ) {
        platformId;
    }

    ngOnInit() {
        this._isPlatformServer = isPlatformServer(this.platformId);
        this.contextSubscription = this.jssContext.state.subscribe((newState) => {
            this.language = newState.language
          });
        if (!this._isPlatformServer) {
            this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
            this.visibleShowmore = (this.rendering?.fields?.result as any)?.Investment?.length < (this.rendering?.fields?.result as any)?.TotalResults ? true : false;
            //taking the dictionary variable to change it
            this.translate.get("SelectedCardTitle").subscribe((x) => {
                this.SelectedCardTitle = x;
            });
            this.isMobile = this.deviceDetector.isMobile();
            // remove this after implementation is done

            (this.rendering?.fields?.result as any)?.InvestmentProductCategories.forEach((item: any) => {
                const selected = (this.rendering.fields?.result as any)?.SelectedProductCategory?.Name;
                let cat = {
                    name: item.Name,
                    active: selected == item.Name,
                    link: item.Link?.Href,
                };
                this.productCategoryList.push(cat);
            });
            let all = {
                name: (this.rendering?.fields?.result as any)?.Sector?.Name,
                active: (this.rendering.fields?.result as any)?.SelectedProductCategory ? false : true,
                link: (this.rendering?.fields?.result as any)?.Sector.Link?.Href,
            };
            this.productCategoryList.unshift(all);
        }
    }

    ngAfterViewInit() {
        if (!this._isPlatformServer) {
            var _this = this;
            this.swiper = new Swiper(this.swiperSlider?.nativeElement, {
                enabled: true,
                slidesPerView: "auto",
                freeMode: true,
                centeredSlides: false,
                spaceBetween: 24,
                grabCursor: true,
                watchSlidesProgress: true,
                breakpoints: {
                    1024: {
                        enabled: false,
                    },
                },
                on: {
                    activeIndexChange: function () {
                        if(_this.swiper.slides[((_this.rendering?.fields?.result as any)?.Investment.length - 2)].classList.contains("swiper-slide-visible")){
                            _this.showMore();
                          }
                    },
                },
            });
            if(this.swiperFilter){
                this.swiper1 = new Swiper(this.swiperFilter?.nativeElement, {
                    slidesPerView: "auto",
                    freeMode: true,
                    centeredSlides: false,
                    spaceBetween: 24,
                    grabCursor: true,
                    breakpoints: {
                        1024: {
                            enabled: false,
                        },
                    },
                });
                this.swiper1.slideTo(this.swiper1.slides.findIndex( (x:any) => x.children[0].classList.contains("pb-filter--active")));
            }
        }
    }

    ngOnDestroy(): void {
        if (this.contextSubscription) {
            this.contextSubscription.unsubscribe();
        }
      }

    showMore() {
        if (!this._isPlatformServer) {
            var request = {
                Sector: (this.rendering.fields?.result as any)?.Sector.Path ,
                PageSize: 3,
                Skip: (this.rendering?.fields?.result as any)?.Investment.length,
                ExtraProducts: (this.rendering?.fields?.result as any)?.ExtraProducts,
                InvestmentCategory: (this.rendering.fields?.result as any)?.SelectedProductCategory
                    ? (this.rendering.fields?.result as any)?.SelectedProductCategory?.Path
                    : (this.rendering.fields?.result as any)?.Sector?.Path,
            };
            this.apiService.fetch<any>("/piraeusapi/products/investment/getInvestments", request).then((resp) => {

                if (resp.status === 200) {
                    if (resp.data) {
                        (this.rendering?.fields?.result as any)?.Investment.push(...resp.data);
                        this.visibleShowmore = (this.rendering?.fields?.result as any)?.Investment.length < (this.rendering?.fields?.result as any)?.TotalResults ? true : false;
                    }
                }
            });
        }
    }
}

interface ProductCategory {
    name: string;
    active: boolean;
    link: string;
}
